@for (field of fields; track field) { @switch (field.type) {
<!-- Text Input -->
@case (FormControlType.INPUT) {
<mat-form-field class="fill" appearance="outline">
  <mat-label>{{ field.label }}</mat-label>
  <input
    matInput
    [formControl]="field.formControl"
  />
  @if (field.formControl.hasError('required') || field.formControl.hasError('pattern')) {
  <mat-error> {{ 'VALIDATION.REQUIRED' | translate }} </mat-error>
  }
</mat-form-field>
}
<!-- Email Input -->
@case (FormControlType.EMAIL) {
<mat-form-field class="fill" appearance="outline">
  <mat-label>{{ field.label }}</mat-label>
  <input
    matInput
    type="email"
    [formControl]="field.formControl"
  />
  @if (field.formControl.hasError('required') || field.formControl.hasError('pattern')) {
  <mat-error> {{ 'VALIDATION.REQUIRED' | translate }} </mat-error>
  } @else if (field.formControl.hasError('invalidEmail')) {
  <mat-error> {{ 'VALIDATION.EMAIL_INVALID' | translate }} </mat-error>
  }
</mat-form-field>
}
<!-- Phone Input -->
@case (FormControlType.PHONE) {
<app-phone-input
  class="phone-field"
  [formControl]="field.formControl"
  [label]="field.label"
  [required]="field.required"
></app-phone-input>
}
<!-- Select Input -->
@case (FormControlType.SELECT) {
<label class="field-label"
  >{{ field.label }}@if (field.required) {<span class="field-required" aria-hidden="true">*</span>}</label
>
<mat-form-field class="fill" appearance="outline" subscriptSizing="dynamic">
  <mat-select
    [formControl]="field.formControl"
    [placeholder]="'VALIDATION.SELECT_AN_OPTION' | translate"
    [attr.aria-label]="field.label"
  >
    @for (option of field.config?.options; track option) {
    <mat-option [value]="option.value">
      {{ option.text }}
    </mat-option>
    }
  </mat-select>
  @if (field.formControl.hasError('required')) {
  <mat-error> {{ 'VALIDATION.REQUIRED' | translate }} </mat-error>
  }
</mat-form-field>
}
<!-- Multiple Choice (checkbox group) -->
@case (FormControlType.CHECKBOX_GROUP) {
<div class="checkbox-group">
  <label class="checkbox-group-label"
    >{{ field.label }}@if (field.required) {<span class="field-required" aria-hidden="true">*</span>}</label
  >
  @for (option of field.config?.options; track option) {
  <mat-checkbox
    color="primary"
    [checked]="isOptionChecked(field, option.value)"
    (change)="toggleOption(field, option.value, $event.checked)"
  >
    {{ option.text }}
  </mat-checkbox>
  }
  @if (field.formControl.touched && field.formControl.hasError('required')) {
  <mat-error class="checkbox-group-error"> {{ 'VALIDATION.REQUIRED' | translate }} </mat-error>
  }
</div>
} } }
